<template>
  <div class="topbar">
    <nav class="navbar navbar-expand-lg">
      <router-link class="navbar-brand" tag="a" to="#"></router-link>

      <div class="ml-auto navbar-nav align-items-center">
        <ul class="type-switcher" v-if="hasFrontendAccess">
          <li>{{ lang.kind }}</li>
          <li class="nav-item active">
            <a class="nav-link">
              <i class="cs-car"></i>
            </a>
          </li>
          <li class="nav-item">
            <a class="nav-link">
              <i class="cs-bike"></i>
            </a>
          </li>
        </ul>
        <ul class="profile">
          <li class="nav-item">
            <a
              class="nav-link nav-link-user"
              id="profiledropdown"
              data-toggle="dropdown"
              aria-haspopup="true"
              aria-expanded="false"
            >
              <i class="cs-user"></i>
              {{ user ? user.name : ''}}
            </a>

            <div class="dropdown-menu" aria-labelledby="dropdownMenu2">
              <ul>
                <!-- <li class="nav-items" v-if="hasFrontendAccess">
                  <router-link tag="a" to="/dashboard.php" class="nav-link">
                    <i class="cs-dashboard"></i>
                    {{ lang.dashboard }}
                  </router-link>
                </li> -->
                <li class="nav-items">
                  <router-link tag="a" to="/account" class="nav-link">
                    <i class="cs-profiles"></i>
                    {{ i18n.app.components.account.my_account }}
                  </router-link>
                </li>
                <li class="nav-items">
                  <a @click="onLogoutClick" class="nav-link">
                    <i class="cs-logout"></i>{{ lang.logout }}
                  </a>
                </li>
              </ul>
            </div>
          </li>
        </ul>
      </div>
    </nav>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";

export default {
  name: "topbar",
  props: ["title", "path"],
  data() {
    return {
      lang: i18n.app.components.topbar
    };
  },
  methods: {
    /**
     * $router.go() takes a history delta, not a path, so go("/login") was a
     * no-op: signing out cleared the token and left the user on the page they
     * were already on, still looking at their own data until a reload.
     *
     * No ?reason= here. This one is deliberate, and the login screen only
     * explains logouts the user did not ask for (RR-330).
     */
    onLogoutClick() {
      this._logout()
        .catch(() => {})
        .then(() => this.$router.push({ name: "login" }));
    },
    ...mapActions({
      _logout: "logout"
    }),
  },
  computed: {
    ...mapGetters({
      user: "user",
      hasFrontendAccess: "hasFrontendAccess",
    })
  }
};
</script>
